import AiconeLogo from '@/components/AiconeLogo/AiconeLogo.vue';
import GlobalSearch from '@/components/probaworkflows_base_components/GlobalSearch/GlobalSearch.vue';
import SystemNotifications from '@/components/probaworkflows_base_components/SystemNotifications/SystemNotifications.vue';
import UserProfileComponent from '@/components/probaworkflows_base_components/UserProfileComponent/UserProfileComponent.vue';
import {
  AIC_ONE_LOGOUT_URL,
  GENERATE_SHARE_LINK,
  SEND_SHARE_LINK_EMAIL, // <-- ADDED THIS
  get_headers,
  get_token,
  get_user_role
} from '@/utils/constants/constants.js';
import alert_mixin from '@/utils/mixins/alert_mixin';

import axios from 'axios';

export default {
  name: 'NavBar',
  mixins: [alert_mixin],
  components: {
    SystemNotifications,
    GlobalSearch,
    UserProfileComponent,
    AiconeLogo, 
  },

  props: {
    show_mobile_drawer: Boolean,
    hide_hamburger: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    entity_name: sessionStorage.getItem('entity_name'),
    show_notifications: false,
    unread_notifications_count: 0,
    show_drop_down: false,
    user_role: null,
    show_modal: false,
    is_sidebar_collapsed: false,
    searchQuery: '',
    show_global_search: false,
    share_link: '',
    share_email: '',
    show_profile_modal: false,
    current_user_id: Number(sessionStorage.getItem('user_id')) || null,
    headers: {},
    token: "",
    project_id: sessionStorage.getItem('project_id'),
    company_name : sessionStorage.getItem('company_name')
  }),

  computed: {
    userDisplayRole() {
      if (this.user_role === 'Entity') {
        const leadId = sessionStorage.getItem('lead_id');
        return leadId && leadId !== 'null' ? 'Lead' : 'Founder';
      }
      return this.user_role;
    },

    should_show_navbar() {
      const allowed_routes = [
        '/company_management',
        '/configure_company_management',
        '/user_management',
        '/roles_management',
        '/permission_management',
        '/action_management',
        '/assigning_permissions',
        '/creating_a_policy',
        '/manage_entity_type',
        '/manage_questions',
        '/view_template',
        '/signing_workflow',
        '/form_management',
        '/status_management',
        '/data_points',
        '/manage_risks',
        '/create_enquiry_stages',
        '/view_entity_type',
        '/create_entity',
        '/configure_template',
        '/manage_assigned_workflows',
        '/upload_template',
        '/risk_questions',
        '/create_enquiry_form',
        '/assign_questions_to_enquiry_form',
        '/services',
        '/package_services',
        '/verification_services_configurations',
        '/company_management'
      ];
      return allowed_routes.includes(this.$route.path);
    },
  },

  methods: {
    handle_search_input() {
      this.show_global_search = this.searchQuery.length > 0;
      this.$refs.global_search?.handle_search(this.searchQuery);
    },

    toggle_notifications() {
      this.show_notifications = !this.show_notifications;
      if (this.show_notifications) {
        this.$refs.system_notifications?.get_unread_notifications();
      }
    },

    update_unread_count(count) {
      this.unread_notifications_count = count;
    },

    go_back() {
      if (this.get_back_route) {
        this.$router.push(this.get_back_route.path);
      }
    },

    toggle_drop_down() {
      this.show_drop_down = !this.show_drop_down;
    },

    open_profile_modal() {
      this.show_profile_modal = true;
    },

    close_profile_modal() {
      this.show_profile_modal = false;
    },

    go_to_home() {
      this.$router.push('/company_management');
    },

    go_to_home_for_trusts() {
      this.$router.push('/entity_overview');
    },

    go_to_profile_menu() {
      this.close_drop_down();

      if (this.user_role === 'Entity') {
        this.$router.push('/entity_overview');
        return;
      }

      this.$router.push('/company_management');
    },

    close_drop_down() {
      this.show_drop_down = false;
    },

    open_modal() {
      this.show_modal = true;
    },

    close_modal() {
      this.show_modal = false;
    },

    handle_click_outside(event) {
      if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
        this.close_drop_down();
      }
    },

    logout() {
      this.close_drop_down();
      this.close_profile_modal();
      const is_aic_one_login = sessionStorage.getItem('is_aic_one_login') === "True";

      if (is_aic_one_login) {
        axios.post(AIC_ONE_LOGOUT_URL, {}, { headers: this.headers })
          .then(response => {
            localStorage.clear();
            sessionStorage.clear();
            window.location = response.data.redirect_url;
          })
          .catch(error => {
            console.warn("error: ", error);
          });

      } else {
        localStorage.clear();
        sessionStorage.clear();
        this.$router.push('/');
      }
    },

    // ---------------------------------------------------------
    // GENERATE SHARE LINK
    // ---------------------------------------------------------
    async generate_share_link() {
      const data = { project_id: this.project_id };

      await axios.post(GENERATE_SHARE_LINK, data, {
        headers: this.headers,
      })
      .then(response => {
        const response_data = response.data;

        if (response_data.status === 'success') {
          this.share_link = response_data.data.share_link;
        }
      })
      .catch(error => {
        if (error.response && error.response.data) {
          this.show_error(error.response.data.message);
        }
      });
    },

    copy_link() {
      if (!this.share_link) {
        return;
      }

      navigator.clipboard.writeText(this.share_link)
        .then(() => {
          this.show_success('Link copied to clipboard!');
        })
        .catch(() => {
          this.show_error('Could not copy link.');
        });
    },

    // ---------------------------------------------------------
    // NEW: SEND SHARE LINK VIA EMAIL
    // * Uses same pattern as GENERATE_SHARE_LINK *
    // ---------------------------------------------------------
    async share_via_email() {
      if (!this.share_email) {
        this.show_error("Please enter an email address.");
        return;
      }

      if (!this.share_link) {
        this.show_error("Please generate the link first.");
        return;
      }

      const data = {
        email: this.share_email,
        share_link: this.share_link,
      };

      await axios.post(SEND_SHARE_LINK_EMAIL, data, { headers: this.headers })
      .then(response => {
        if (response.data.status === "success") {
          this.show_success("Email sent successfully!");
          this.share_email = "";
        }
      })
      .catch(error => {
        if (error.response && error.response.data) {
          this.show_error(error.response.data.message);
        } else {
          this.show_error("Failed to send email.");
        }
      });
    },
  },

   watch: {
  $route() {
    this.$nextTick(() => {
      this.company_name = sessionStorage.getItem('company_name');
      this.project_id = sessionStorage.getItem('project_id');
      this.entity_name = sessionStorage.getItem('entity_name');
    });
  }
  },
 

  async created() {
    this.user_role = await get_user_role();

    if (this.$refs.system_notifications) {
      this.$refs.system_notifications.get_unread_notifications();
    }
  },

  mounted() {
    this.headers = get_headers();
    this.token = get_token();
    this.company_name = sessionStorage.getItem('company_name');
    document.addEventListener("click", this.handle_click_outside);

    this.$nextTick(() => {
      if (this.$refs.system_notifications) {
        this.$refs.system_notifications.get_unread_notifications();
      }
    });
  },

  beforeUnmount() {
    document.removeEventListener("click", this.handle_click_outside);
  },
};
